//Redux store config

import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';
import gameSlice from './slices/gameSlice';
import forestSlice from './slices/forestSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    ui: uiSlice,
    game: gameSlice,
    forest: forestSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/setUser'],
        ignoredPaths: ['auth.user.createdAt', 'auth.user.updatedAt'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
